export default function GeneralSettings() {
  return <div>General</div>;
} 